import React from "react";
import {Col, Row} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, isResponseOk, isValidEmail, queryParams} from "enqc-utilities/src/utils/Utilities";
import {storeData} from "../../utils/StorageUtil";
import Global from "../../utils/Global";
import label from "enqc-utilities/src/label/Label";
import {toasting} from "../base/BaseComponent";
import {isValidNumber} from "libphonenumber-js";
import {AuthConsumer} from "../../context/AuthContext";
import AssemblerCard from "../../components/assembler/AssemblerCard";
import ControllerFWVersionCard from "../../components/assembler/ControllerFWVersionCard";
import AssemblyBasicInformationCard from "../../components/assembler/AssemblyBasicInformationCard";
import AssemblyHistoryInformationCard from "../../components/assembler/AssemblyHistoryInformationCard";
import ComponentInformationCard from "../../components/assembler/ComponentInformationCard";
import RectifierControllerInformationCard from "../../components/assembler/RectifierControllerInformationCard";
import ModelInformationCard from "../../components/ModelInformationCard";
import AssemblyStatusMessageCard from "../../components/assembler/AssemblyStatusMessageCard";


class AssemblyDetailPage extends BasePage{

  constructor(props) {
    super(props);

    let reference = queryParams(this.props, 'reference')
    let validation = this.defaultValidation()
    let validationMessage = this.defaultValidationMessage()
    this.state = {
      reference:reference,
      assembly : {},
      validation : validation,
      validationMessage : validationMessage,
      modelDetailInformationModal:false
    }
  }

  defaultValidation = () =>{
    let validation = {};
    validation.firstname = true ;
    validation.lastname = true ;
    validation.birthdate = true
    validation.mobilePhone = true
    validation.gender = true ;
    validation.email = true
    validation.address = true ;
    validation.province = true ;
    validation.city = true
    validation.district = true ;
    validation.village = true
    return validation ;
  }
  defaultValidationMessage = () =>{
    let validationMessage = {};
    validationMessage.firstname = "" ;
    validationMessage.lastname = "" ;
    validationMessage.birthdate = ""
    validationMessage.mobilePhone = ""
    validationMessage.gender = "" ;
    validationMessage.email = ""
    validationMessage.address = "" ;
    validationMessage.province = "" ;
    validationMessage.city = ""
    validationMessage.district = "" ;
    validationMessage.village = ""
    return validationMessage ;
  }
  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([AssemblyDetailPage.PAGE_CONF])
    }
    this.closePreLoader()
    this.fetchAssemblyDetail()
    // this.refreshAssembly((assembly)=>{this.setState({assembly})})
  }

  onChangeGeneralForm(field, value){
    let {assembly, validation, validationMessage} = this.state
    if(field==='firstname'){
      validation.firstname = true
      validationMessage.firstname = ""
    }
    if(field==='email'){
      validation.email = true
      validationMessage.email = ""
    }
    if(field==='mobilePhone'){
      validation.mobilePhone = true
      validationMessage.mobilePhone = ""
    }
    if(field==='province'){
      validation.province = true
      validationMessage.province = ""
    }
    if(field==='city'){
      validation.city = true
      validationMessage.city = ""
    }
    if(field==='district'){
      validation.district = true
      validationMessage.district = ""
    }
    if(field==='village'){
      validation.village = true
      validationMessage.village = ""
    }
    assembly[field] = value
    this.setState({assembly, validation, validationMessage})
  }

  async validateFormSubmit() {
    // await super.validateFormSubmit();
    let {assembly, validation, validationMessage} = this.state
    let valid = true ;
    validation = this.defaultValidation()
    validationMessage = this.defaultValidationMessage()
    if(isEmpty(assembly.mobilePhone) || assembly.mobilePhone.length <=2){
      validation.mobilePhone = false
      validationMessage.mobilePhone = label.PleaseEnterCorrectPhoneNumber
      valid = false ;
    }
    if(!isValidNumber(assembly.mobilePhone, 'ID')){
      validation.mobilePhone = false
      validationMessage.mobilePhone = label.PleaseEnterCorrectPhoneNumber
      valid = false ;
    }
    if(isEmpty(assembly.firstname) || assembly.firstname.length <=2){
      validation.firstname = false
      validationMessage.firstname = label.PleaseEnterFirstName
      valid = false ;
    }
    if(isEmpty(assembly.email) || assembly.email.length <=2){
      validation.email = false
      validationMessage.email = label.PleaseEnterEmail
      valid = false ;
    }
    if(!isValidEmail(assembly.email)){
      validation.email = false
      validationMessage.email = label.PleaseEnterCorrectEmail
      valid = false ;
    }

    if(!isEmpty(assembly.address) || !isEmpty(assembly.province) || !isEmpty(assembly.city) || !isEmpty(assembly.district) || !isEmpty(assembly.village)){
      if(isEmpty(assembly.address) || assembly.address.length <=2){
        validation.address = false
        validationMessage.address = label.PleaseEnterAddress
        valid = false ;
      }
      if(isEmpty(assembly.province)){
        validation.province = false
        validationMessage.province = label.PleaseSelectProvince
        valid = false ;
      }
      if(isEmpty(assembly.city)){
        validation.city = false
        validationMessage.city = label.PleaseSelectCity
        valid = false ;
      }
      if(isEmpty(assembly.district)){
        validation.district = false
        validationMessage.district = label.PleaseSelectDistrict
        valid = false ;
      }
      if(isEmpty(assembly.village)){
        validation.village = false
        validationMessage.village = label.PleaseSelectVillage
        valid = false ;
      }
    }
    this.setState({assembly, validation, validationMessage}, async () => {
      if(valid){
        await this.save()
      }
    })
  }

  fetchAssemblyDetail(){
    let {reference} = this.state
    this.showPostProgress()
    this.get(Endpoint.API.ASSEMBLY, {
      params :{
        reference : reference
      }
    }, null, response=>{
      if(response.code===200){
        let assembly = response.data
        this.setState({
          assembly:assembly,
        }, () => {
          this.closePostProgress()
        })
      }else{
        this.closePostProgress()
        this.props.history.goBack();
      }
    }, false, true)
  }



  async save(){
    let {assembly} = this.state
    let formData = new FormData()
    formData.append("assemblyDtoGson",JSON.stringify(assembly))
    this.post(Endpoint.API.USER_SAVE, formData, null, (res)=>{
      if(isResponseOk(res)){
        toasting.success(label.SuccessUpdatingData)
        let assembly = res.data
        storeData(Global.USER, assembly)
        this.setState({assembly})
      }else{
        toasting.error(res.message)
      }
    }, true, false)
  }

  validate(){

  }


  render(){
    let {assembly, modelDetailInformationModal, validation,validationMessage} = this.state
    if(isEmpty(assembly)){
        assembly = {}
    }
    let model = assembly.model?assembly.model:{}
    let user = assembly.user?assembly.user:{}
    return (
        <AuthConsumer>
          {({ isAuth, refresh }) => {
            return (
                <>
                  <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2">
                    <h4>{label.AssemblyInformation}</h4>
                  </div>
                  <Row>
                    <Col xs={12} xl={3}>
                      <Row>
                        <Col xs={12}>
                          <AssemblerCard
                              user={user}
                              showProcessing={this.props.showProcessing}
                              closeProcessing={this.props.closeProcessing}
                              onRefresh={(user)=>{}}/>
                        </Col>
                        <Col xs={12}>
                          <ModelInformationCard model={model}/>
                        </Col>
                        <Col xs={12}>
                          <AssemblyHistoryInformationCard
                              assembly={assembly}/>
                        </Col>
                        <Col xs={12}>
                          {/*<Assembly5LastActivityCard assembly={assembly} onRefresh={() => {}}/>*/}
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12} xl={9}>
                      <Row>
                        <Col md={12}>
                          <AssemblyBasicInformationCard
                              {...this.props}
                              assembly={assembly}/>
                        </Col>
                      </Row>
                      {assembly.statusMessage&&(
                          <Row>
                            <Col md={12}>
                              <AssemblyStatusMessageCard
                                  assembly={assembly}/>
                            </Col>
                          </Row>
                      )}
                      <Row>
                        <Col md={12}>
                          <ControllerFWVersionCard
                              assembly={assembly}/>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <ComponentInformationCard
                              assembly={assembly}/>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <RectifierControllerInformationCard
                              assembly={assembly}/>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {super.render()}
                </>
            )
          }}
        </AuthConsumer>
    );
  };
}
// export default Object.assign(ProfilePage, {ENDPOINT : "/profile"})

const ENDPOINT = "/assembly/detail"
const TITLE = label.AssemblyInformation
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(AssemblyDetailPage, PAGE)
